import { getSystemUiModuleList } from "@src/redux/index";
import { Form, Select } from "antd";
import React from "react";
import { useSelector } from "react-redux";

const HomeUiModule: React.FC = () => {
  const { result } = useSelector(getSystemUiModuleList);

  return (
    <Form.Item
      name="homeUiModuleId"
      label="Page"
      rules={[
        {
          required: true,
          message: "Page is required.",
        },
      ]}
    >
      <Select
        options={result?.items || []}
        showSearch
        fieldNames={{ value: "id", label: "name" }}
        filterOption={(input, option) =>
          (option?.name ?? "").toLowerCase().includes(input.toLowerCase())
        }
      />
    </Form.Item>
  );
};

export default HomeUiModule;
